import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import RenderShopButton from '../ShopButton.js';
import { ReactComponent as PlusIcon } from '../../images/icons/plus.svg';
import { ReactComponent as XIcon } from '../../images/icons/x-icon.svg';

export default function Header(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('768'));
  const [navOpen, setNavOpen] = useState(false);
  const activePage = props.activePage === '' ? '' : props.activePage;

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  const componentLoading = useSelector(state => get(state, 'prismic.header.loading', true));
  const component = useSelector(state => get(state, 'prismic.header.data', false));
  const logo = get(component, 'logo.url', false);
  const navigationLinks = get(component, 'navigation', false);

  const renderNavLinks = navigationLinks => {
    return navigationLinks.map((el, i) => {
      return (
        <li key={i}>
          <Link
            onClick={() => {
              setNavOpen(false);
            }}
            to={`/${el.link_url.uid}`}
            className={activePage === `/${el.link_url.uid}` ? 'active' : undefined}>
            {el.link_text[0].text}
          </Link>
        </li>
      );
    });
  };

  if (componentLoading) {
    return <div style={{ height: '80px', width: '100%', background: 'white' }}></div>;
  }

  return (
    !componentLoading &&
    component && (
      <>
        <header>
          <nav>
            <div className="nav-wrapper">
              <div className="mobile-bar-wrapper">
                <a href="/" aria-label="homepage link">
                  <figure id="nav-logo" className="ml-25">
                    <img src={logo} alt="" role="presentation"></img>
                  </figure>
                </a>
                {isMobile && (
                  <IconButton
                    onClick={toggleNav}
                    className={`menu-icon ${navOpen ? 'animate-burger' : ''}`}
                    aria-label={!navOpen ? 'open navigation' : ''}
                    style={{ marginRight: '20px' }}>
                    {!navOpen ? <PlusIcon /> : <XIcon />}
                  </IconButton>
                )}
              </div>
              <ul className={!navOpen ? '' : 'openNav'}>
                {renderNavLinks(navigationLinks)}
                {isMobile && (
                  <>
                    <li>
                      <Link
                        to="/shop"
                        onClick={() => {
                          setNavOpen(false);
                        }}>
                        Buy Online
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/store-locator"
                        onClick={() => {
                          setNavOpen(false);
                        }}>
                        Store Locator
                      </Link>
                    </li>
                  </>
                )}
                {!isMobile && <RenderShopButton />}
              </ul>
            </div>
          </nav>
        </header>
      </>
    )
  );
}
